import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import p4lLogo from "../assets/logo/PfL Logo no words 2023-11-21-01.png";
import { useAuth } from "../contexts/AuthContext";
import Button from "../componentLibrary/Button";
import SideNav from "./SideNav";
import SearchSider from "./SearchSider/SearchSider";

const Header = ({ transparent = false }) => {
  const { isAuthenticated: isAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === "/login";
  const isSignupPage = location.pathname === "/signup";

  // Helper function to determine if auth buttons should be shown
  const shouldShowAuthButtons = !isAuth && !isLoginPage && !isSignupPage;

  const handleLogoClick = (e: React.MouseEvent) => {
    if (isAuth) {
      e.preventDefault();
      navigate("/explore", { state: { resetFilters: true }, replace: true });
    }
  };

  return (
    <nav
      className={`${transparent ? "bg-transparent" : "bg-gray-100"} shadow-md z-[60] fixed top-0 left-0 right-0`}
    >
      <div className="w-full px-4">
        {/* Top row - Logo, Hamburger, and Desktop Buttons */}
        <div className="flex items-center min-h-12">
          <Link
            to={isAuth ? "/explore" : "/"}
            onClick={handleLogoClick}
            className="absolute left-1/2 transform -translate-x-1/2 flex items-center"
          >
            <img
              src={p4lLogo}
              alt="Psych For Life logo"
              className="w-8 h-8 mr-2"
            />
            <p
              className={`${transparent ? "text-gray-800 drop-shadow-md" : "text-gray-700"}`}
            >
              Psych For Life<sup>®</sup>
            </p>
          </Link>
          <div className="flex w-full justify-between">
            <SideNav />
            {/* Desktop buttons - hidden on mobile */}
            {shouldShowAuthButtons && (
              <div className="hidden lg:flex items-center space-x-3">
                <Link to="/signup">
                  <Button variant="secondary" roundedFull>
                    Have an access code? Sign Up
                  </Button>
                </Link>
                <Link to="/login">
                  <Button variant="dark" roundedFull>
                    Log in
                  </Button>
                </Link>
              </div>
            )}
            {isAuth && <SearchSider />}
          </div>
        </div>

        {/* Bottom row - Mobile buttons only */}
        {shouldShowAuthButtons && (
          <div className="flex lg:hidden justify-center pb-2">
            <div className="flex items-center space-x-3">
              <Link to="/signup">
                <Button variant="secondary" roundedFull>
                  <div className="flex flex-col lg:flex-row lg:items-center leading-tight">
                    <span>Have an access code?</span>
                    <span className="lg:ml-1 -mt-1 lg:mt-0">Sign Up</span>
                  </div>
                </Button>
              </Link>
              <Link to="/login">
                <Button variant="dark" roundedFull>
                  Log in
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
